import { defineComponent as _defineComponent } from 'vue'
import { useContext, useStore } from '@nuxtjs/composition-api';
import WarRoomPostPreviewPresenter from '@/components/partials/war-room/WarRoomPostPreviewPresenter/WarRoomPostPreviewPresenter.vue';
import { votableTypes } from '@/components/partials/war-room/constants';
import type { IPost } from '@/types/community';
import type { RootState } from '@/types/store';

type WarRoomPostPreviewProps = {
  post: IPost;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostPreview',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
  post: IPost;
};


const store = useStore<RootState>();
const { $analytics, $notice, $sentryUtils, $auth } = useContext();

async function handleAddVote(value: number): Promise<void> {
  $analytics?.logEvent(`war-room__post__rating__set`, { value });

  try {
    await store.dispatch('warRoom/addVote', { votable: props.post, type: votableTypes.POST, value });
  } catch (e) {
    if (e instanceof Error) {
      $notice.error(e);
    }
    $sentryUtils.error(e);
  }
}

async function handleRemoveVote(): Promise<void> {
  $analytics?.logEvent(`war-room__post__rating__unset`);

  try {
    await store.dispatch('warRoom/removeVote', { votable: props.post, type: votableTypes.POST });
  } catch (e) {
    $notice.error(e);
    $sentryUtils.error(e);
  }
}

async function handlePollVote(choiceId: number): Promise<void> {
  if (!$auth.loggedIn) {
    return;
  }

  try {
    $analytics?.logEvent('war-room__post-preview__poll-choice__click', { choiceId });
    await store.dispatch('warRoom/addPollChoice', { postSlug: props.post.slug, choiceId });
  } catch (e) {
    if (e instanceof Error) {
      $notice.error(e);
    }
    $sentryUtils.error(e);
  }
}

return { __sfc: true,props, store, $analytics, $notice, $sentryUtils, $auth, handleAddVote, handleRemoveVote, handlePollVote, WarRoomPostPreviewPresenter }
}

})